/** @license ISC License (c) copyright 2019 original and current authors */
/** @author Dale Francis (dalefrancis88) */

// isTrue : a -> Boolean
function isTrue(x) {
  return x === true
}

module.exports = isTrue
